import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { toastr } from "react-redux-toastr";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  Popup,
  Modal,
  //Button,
} from "semantic-ui-react";
import { imageDomain } from "../configC/keys";
import { RiDeleteBin5Line } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import { RiImageAddLine } from "react-icons/ri";
import Confirm from "../common/Confirm_1";
import { searchAwards } from "../../actions/awardAction";
import ModalGr from "../modalGr/Modal";
import AwardEdit from "../create/AwardEdit";
import AddImageSingle from "../imageUpload/AddImageSingle";

const Awards = (props) => {
  const [state, setState] = useState({
    play: true,
    stop: false,
    open: false,
    editModalOpen: false,
    imgModalOpen: false,
  });

  const activePlay = () => {
    setState({ ...state, play: true, stop: false });
  };

  const activeStop = () => {
    setState({ ...state, play: false, stop: true });
  };

  const refresh = () => {
    props.searchAwards();
    // window.scroll(0, 0);
  };
  const show = (id) => {
    setState({ ...state, open: true, id: id });
  };

  //******************* */
  const handleConfirm = async () => {
    const did = state.id;

    //************
    try {
      //^^^^^^^^^^^^^^^^^
      const res = await axios.put(`/api/AwardDelete/${did}`);

      if (res.data.msg === "success") {
        refresh();
        setState({ ...state, open: false });
        toastr.success("Deleted Successfully");
      }
    } catch (error) {
      if (error && error.response && error.response.status == 401) {
        this.props.openModal("LoginModal");
        toastr.error(`${JSON.stringify(error.response.data)}`);
      } else if (error) {
        toastr.error(
          "Oops",
          "Something went wrong.Please Try Again_deleteAward"
        );
      }
    }
    //**********
  };

  const handleCancel = () => setState({ ...state, open: false });
  //**********************************
  const handleEditModalOpen = (id) =>
    setState({ ...state, editModalOpen: true, id: id });
  const handleEditModalClose = () => {
    setState({ ...state, editModalOpen: false });
  }; //
  const handleEditModalCloseSubmit = () => {
    refresh();
    setState({ ...state, editModalOpen: false });
  };
  //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

  const handleImgModalOpen = (id, img) =>
    setState({ ...state, imgModalOpen: true, id: id, path: img });
  const handleImgModalClose = () => {
    setState({ ...state, imgModalOpen: false });
  }; //
  const handleImgModalCloseSubmit = () => {
    refresh();
    setState({ ...state, imgModalOpen: false });
  };
  const renderPopupState = () => {
    if (window.innerWidth < 600) {
      return true;
    }
    if (window.innerWidth > 600) {
      return false;
    }
  };
  const settings = {
    autoplay: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 700,
    // initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      // {
      //   breakpoint: 1024,
      //   settings: {
      //     slidesToShow: 3,
      //     slidesToScroll: 1,
      //     infinite: true,
      //     dots: true
      //   }
      // },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          // initialSlide: 2
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  let sliderRef = useRef(null);
  const next = () => {
    sliderRef.slickNext();
  };
  const previous = () => {
    sliderRef.slickPrev();
  };
  const play = () => {
    sliderRef.slickPlay();
    activePlay();
  };
  const pause = () => {
    sliderRef.slickPause();
    activeStop();
  };
  //*************** */

  const renderPlayStopButton = () => {
    if (state.play) {
      return (
        <Popup
          content={"Stop"}
          disabled={renderPopupState()}
          trigger={
            <span className="icon-button-gr" onClick={pause}>
              <img
                src="/stop.png"
                alt=" "
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "5px",
                  verticalAlign: "middle",
                }}
              />
            </span>
          }
        />
      );
    }
    if (state.stop) {
      return (
        <Popup
          content={"Play"}
          disabled={renderPopupState()}
          trigger={
            <span className="icon-button-gr" onClick={play}>
              <img
                src="/play.png"
                alt=" "
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "5px",
                  verticalAlign: "middle",
                }}
              />
            </span>
          }
        />
      );
    }
  };

  //^^^^^^^^^^
  //*************** */
  const renderList = (award) => {
    const { head, img, _id } = award;
    //******************
    const renderDeleteButton = () => (
      <Popup
        content={"Delete"}
        disabled={renderPopupState()}
        trigger={
          <span onClick={() => show(_id)} className="">
            <RiDeleteBin5Line
              className="icon-gr"
              style={{ backgroundColor: "red" }}
            />
          </span>
        }
      />
    );
    //^^^^^^^^^^^
    const renderEditButton = () => (
      <Popup
        content={"Edit"}
        disabled={renderPopupState()}
        trigger={
          <span onClick={() => handleEditModalOpen(_id)} className="">
            <FaRegEdit
              className="icon-gr"
              style={{ backgroundColor: "dodgerblue" }}
            />
          </span>
        }
      />
    );

    const renderAddImageButton = () => (
      <Popup
        content={"Add Image"}
        disabled={renderPopupState()}
        trigger={
          <span onClick={() => handleImgModalOpen(_id, img)} className="">
            <RiImageAddLine
              className="icon-gr"
              style={{ backgroundColor: "skyblue" }}
            />
          </span>
        }
      />
    );
    //******************
    return (
      // <div key={_id}>

      <div
        key={_id}
        className="card-award bgColor-gr1 direction-c"
        style={{ position: "relative" }}
      >
        {/* <div className="mt-10 mb-10"
      style={{position:'absolute',top:'0px',}}
        >
          {renderEditButton()}
          {renderDeleteButton()}
          {renderAddImageButton()}
        </div> */}
        <div
          style={{
            flex: "15%",
            display: "flex",
            justifyContent: "center",
            padding: "5px",
          }}
        >
          <p className="font-18B">{head}</p>
        </div>
        <div
          style={{
            flex: "80%",
            display: "flex",
            justifyContent: "center",
            padding: "5px",
          }}
        >
          <div>
            <img
              className="img-border-bg  imgDimention-award "
              src={`${imageDomain}${img}`}
            />
            {/* <Image small className="img-border-bg " src={img} /> */}
            <div
              className="mt-10 mb-10"
              style={{ position: "absolute", bottom: "50px" }}
            >
              {props.userA !== null &&
                  (props.userA.userType === 'admin' || props.userA.userType === 'manager_dwk' || props.userA.userType === 'manager_ggn') &&
                renderEditButton()}
              {props.userA !== null &&
                  (props.userA.userType === 'admin' || props.userA.userType === 'manager_dwk' || props.userA.userType === 'manager_ggn') &&
                renderDeleteButton()}
              {props.userA !== null &&
                  (props.userA.userType === 'admin' || props.userA.userType === 'manager_dwk' || props.userA.userType === 'manager_ggn') &&
                renderAddImageButton()}
            </div>
          </div>
        </div>
      </div>
      // </div>
    );
  };

  //*************** */
  return (
    <section className="padding-gr-outer bgColor-gr1 ">
      <div className="inner-gr bgColor-gr1">
        <div className="headtitl">
          <div className="line-height-gr font-36B color-CornflowerBlue px-20">
            Awards &<span> Recognitions</span>
          </div>

          <div className="font-24B px-20">
            <p>
              When we work to achieve the Best, World helps us to get the
              Bestest
            </p>
            <p className="font-18B ">
              Here are some of the glimpses of our achievements during our
              journey
            </p>
          </div>
          <div className="devider"></div>
        </div>

        {/*  */}
        <div
          style={{ margin: "auto", maxWidth: "1140px" }}
          className="slider-container"
        >
          <Slider
            ref={(slider) => {
              sliderRef = slider;
            }}
            {...settings}
          >
            {props.state.awards.awards.map((item) => renderList(item))}
          </Slider>

          <div style={{ textAlign: "center" }}>
            <Popup
              content={"Previous"}
              disabled={renderPopupState()}
              trigger={
                <span className="icon-button-gr" onClick={previous}>
                  <img
                    src="/pre.png"
                    alt=" "
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "5px",
                      verticalAlign: "middle",
                    }}
                  />
                </span>
              }
            />

            {renderPlayStopButton()}
            <Popup
              content={"Next"}
              disabled={renderPopupState()}
              trigger={
                <span className="icon-button-gr" onClick={next}>
                  <img
                    src="/next.png"
                    alt=" "
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "5px",
                      verticalAlign: "middle",
                    }}
                  />
                </span>
              }
            />
          </div>
        </div>

        {/*  */}
      </div>

      {/* img modal */}
      {/* {state.imgModalOpen && (
        <Modal
          open={state.imgModalOpen}
          onClose={handleImgModalClose}
          basic
          closeOnEscape={false}
          closeOnDimmerClick={false}
          // size='small'
        >
          <Modal.Content>
            <AddImageSingle
              hasCloseBtn={true}
              handleCloseModal={handleImgModalClose}
              id={state.id}
              path={state.path}
              handleImgModalCloseSubmit={handleImgModalCloseSubmit}
              hasDimention={true}
              // height={280}
              // width={425}
              folder={"award"}
              apiRoute={`/api/AwardEditForAddImagePath`}
            />
          </Modal.Content>
        </Modal>
      )} */}
      {/* img modal */}
      {state.imgModalOpen && (
        <ModalGr
          hasCloseBtn={true}
          isOpen={state.imgModalOpen}
          onClose={handleImgModalClose}
          className={"modal-review"}
        >
          <AddImageSingle
            handleImgModalClose={handleImgModalClose}
            id={state.id}
            path={state.path}
            handleImgModalCloseSubmit={handleImgModalCloseSubmit}
            hasDimention={true}
              // height={280}
              // width={425}
            folder={"award"}
            apiRoute={`/api/AwardEditForAddImagePath`}
          />
          
        </ModalGr>
      )}
      <Confirm
        open={state.open}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
      />

      {/* Edit Modal*/}
      {state.editModalOpen && (
        <Modal
          open={state.editModalOpen}
          onClose={handleEditModalClose}
          basic
          closeOnEscape={false}
          closeOnDimmerClick={false}
          // size='small'
        >
          <Modal.Content>
            <AwardEdit
              id={state.id}
              handleEditModalCloseSubmit={handleEditModalCloseSubmit}
              handleEditModalClose={handleEditModalClose}
            />
          </Modal.Content>
        </Modal>
      )}
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    userA: state.auth.userA,
    state,
  };
};

// export default Awards;
export default connect(mapStateToProps, { searchAwards })(Awards);
